// @flow
import React from 'react';
import { Banner } from 'components/atoms/banner';
import { useViewport } from 'components/templates/viewportProvider';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { StringUtil } from 'utils/StringUtil';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
import { AnnouncementCard } from 'components/molecules/announcementCard';
// eslint-disable-next-line
import styles from "./styles.scss";

// TODO:
type Props = {
  data: Object,
  theme: string,
};

export const MusicFoundationBanner = (props: Props) => {
  const { height, isMobile } = useViewport();
  const {
    data: {
      title,
      description,
      description_mobile,
      image,
      image_mobile,
      thumbnail,
      thumbnail_mobile,
      banner_video,
    },
    theme,
  } = props;

  const descriptionMobile = StringUtil.sliceHtml(description_mobile);

  const renderDescription = () => {
    if (isMobile) {
      return <h3 className={'mobile-description'}>{descriptionMobile}</h3>;
    }

    return null;
  };

  const renderBannerTextMobile = () => {
    return (
      <div className={'banner-text'}>
        <h1>{title}</h1>
        {renderDescription()}
      </div>
    );
  };

  let bannerImageUrl = image;
  let thumbNailUrl = thumbnail;
  let className = 'music-banner';
  let bannerText = title;
  if (isMobile) {
    bannerImageUrl = image_mobile;
    thumbNailUrl = thumbnail_mobile;
    bannerText = renderBannerTextMobile();
  }

  const animationClasses = ['animate-height', 'animate-width'];

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        title={bannerText}
        imageUrl={bannerImageUrl}
        thumbNailUrl={thumbNailUrl}
        bannerText={'animate-text'}
        containerClassName={'intro'}
        bannerImage={animationClasses.join(' ')}
        variableWidth={true}
        description={renderDescription()}
      />
      {/*<AnnouncementCard*/}
      {/*  imageUrl={eventsImage}*/}
      {/*  title={'Lorem Ipsum Dolor set amet'}*/}
      {/*  onClick={''}*/}
      {/*/>*/}
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
      {isMobile && (
        <FooterExploreButton theme={theme} sectionName={'upcoming-shows'} />
      )}
    </div>
  );
};

export default MusicFoundationBanner;
